<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <!-- Botones -->
          <v-card-title primary-title>
            <span class="text-subtitle-1">Administracion de Egresos Programados</span>
            <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small
              dark
              color="green"
              @click="exportExcel(serviciosSistemasFiltrados, 'servicios_sistemas_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="purple"
              dark
              class="mr-2"
              @click="abrirModalRequisicionesPendientes"
              small
              tile
            >
              <v-icon left small>mdi-file-document-multiple</v-icon>
              Generar Requisiciones Pendientes
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <!-- Tabla de items -->
          <v-card-text>
            <v-row dense class="mb-3">
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  label="Vence desde"
                  filled
                  dense
                  hide-details
                  v-model="filtroFechaInicio"
                  type="date"
                  prepend-inner-icon="mdi-calendar-start"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  label="Vence hasta"
                  filled
                  dense
                  hide-details
                  v-model="filtroFechaFin"
                  type="date"
                  prepend-inner-icon="mdi-calendar-end"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="filtroCategoria"
                  :items="categoriasFiltro"
                  label="Categoría"
                  filled
                  dense
                  hide-details
                  clearable
                  item-text="text"
                  item-value="value"
                  prepend-inner-icon="mdi-tag-outline"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  name="search"
                  label="Buscar"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="filtroFechaInicio || filtroFechaFin || filtroCategoria" class="mb-2">
              <v-col cols="12">
                <v-chip small class="mr-2" color="primary" outlined>
                  {{ serviciosSistemasFiltrados.length }} de {{ servicios_sistemas.length }} egresos
                </v-chip>
                <v-chip
                  v-if="filtroCategoria"
                  small
                  close
                  class="mr-2"
                  @click:close="filtroCategoria = null"
                >
                  {{ getNombreCategoria(filtroCategoria) }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="serviciosSistemasFiltrados"
                  class="elevation-0"
                  :search="search"
                  :mobile-breakpoint="100"
                  dense
                >

                  <template v-slot:item.categoria="{ item }">
                    <v-chip
                      v-if="item.tipo_requisicion"
                      small
                      outlined
                      color="primary"
                    >
                      {{ item.tipo_requisicion }}
                    </v-chip>
                    <span v-else class="grey--text">Sin categoría</span>
                  </template>

                  <template v-slot:item.dia_vencimiento="{ item }">
                    <div class="dia-vencimiento-cell">
                      <span class="font-weight-medium">{{ getDiaVencimientoTexto(item) }}</span>
                      <span
                        v-if="getProximoVencimientoLabel(item)"
                        class="dia-vencimiento-cell__proximo"
                      >
                        Próx: {{ getProximoVencimientoLabel(item) }}
                      </span>
                    </div>
                  </template>

                  <template v-slot:item.recurrencia="{ item }">
                    {{ getRecurrenciaText(item.recurrencia) }}
                  </template>

                  <!-- Columna de estado activo/inactivo -->
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip
                      v-if="item.activo_sn == 1"
                      small
                      color="green"
                      dark
                    >Si</v-chip>
                    <v-chip
                      v-else
                      small
                      color="error"
                      dark
                    >No</v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      color="primary"
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                      title="Editar"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      color="error"
                      x-small
                      @click="deleteItem(item)"
                      class="mr-2"
                      title="Borrar"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                    <historial-servicio
                      :servicio="item"
                      ref="historialComponent"
                      @actualizar="initialize"
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal para generar requisiciones pendientes -->
    <v-dialog v-model="dialogRequisicionesPendientes" max-width="1200px" persistent>
      <v-card>
        <v-card-title class="headline">
          Generar Requisiciones Pendientes
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogRequisicionesPendientes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0 mt-2">
          <v-row>

            <v-col cols="12" sm="6" lg="4">
              <v-text-field
                label="Fecha inicio"
                filled
                dense
                hide-details
                v-model="fechaIni"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" lg="4">
              <v-text-field
                label="Fecha final"
                filled
                dense
                hide-details
                v-model="fechafin"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" lg="4">
              <v-radio-group
                v-model="opEscuela"
                row
                dense
                hide-details
              >
                <v-radio
                  label="INBI"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="FAST"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="Todos"
                  :value="3"
                ></v-radio>
              </v-radio-group>

            </v-col>


            <!-- <v-col cols="12" sm="6">
              <v-select
                v-model="filtroVencimiento"
                :items="opcionesFiltroVencimiento"
                label="Filtrar por vencimiento"
                dense
                outlined
                class="mt-0 pt-0"
              ></v-select>
            </v-col> -->

            <v-col cols="12" sm="6" class="d-flex align-center">
              <div v-if="filtroVencimiento !== 'todos'" class="text-caption primary--text">
                Mostrando {{ pagosPendientesFiltrados.length }} de {{ pagosPendientes.length }} pagos
              </div>
            </v-col>
          </v-row>

          <v-row justify="end">
            <v-col cols="12" lg="8">
              <v-text-field
                name="search"
                label="Buscar"
                id="search"
                filled
                dense
                hide-details
                append-icon="mdi-magnify"
                v-model="searchPagos"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="pt-4">
          <v-data-table
            :headers="pagosPendientesHeaders"
            :items="pagosPendientesFiltrados"
            :loading="loadingPagosPendientes"
            item-key="id_pago"
            show-select
            v-model="pagosPendientesSeleccionados"
            :items-per-page="10"
            class="shadowCard"
            @input="actualizarSeleccion"
            :search="searchPagos"
          >
            <!-- Columnas personalizadas aquí -->
            <template v-slot:item="{ item, index }">
              <tr :class="getVencimientoRowClass(item)">
                <td>
                  <v-checkbox
                    v-model="pagosPendientesSeleccionados"
                    :value="item"
                    hide-details
                  ></v-checkbox>
                </td>
                <td>{{ item.nombre_servicio }}</td>
                <td :class="getVencimientoTextClass(item)">{{ item.fechaVencimiento }}</td>
                <td>{{ item.ciclo_nombre }}</td>
                <td>
                  <!-- {{ formatCurrency(item.monto_solicitado) }} -->
                    <v-edit-dialog
                      :return-value.sync="item.monto_solicitado"
                      @save="saveMonto( item ) "
                    >
                      {{ formatCurrency(item.monto_solicitado) }}
                      <template v-slot:input>
                        <v-text-field
                          v-model="item.monto_solicitado"
                          label="Monto Solicitado"
                          single-line
                          counter
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                </td>
                <td>{{ item.proveedorNombre }}</td>
                <td>{{ item.plantel }}</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        icon
                        color="info"
                        class="mx-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="editarPagoProgramado(item)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar pago programado</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:item.fechaVencimiento="{ item }">
              {{ item.fechaVencimiento }}
            </template>
            <template v-slot:item.monto_solicitado="{ item }">
              {{ formatCurrency(item.monto_solicitado) }}
            </template>
          </v-data-table>

          <v-alert
            v-if="pagosPendientes.length === 0 && !loadingPagosPendientes"
            type="info"
            text
            dense
            class="mt-4"
          >
            No hay pagos pendientes para generar requisiciones.
          </v-alert>

          <br/>
          <br/>
          <br/>

          <v-textarea
            v-model="comentariosRequi"
            label="Agrega un comentario para la requisición"
            :rows="3"
            auto-grow
            filled
            dense
            hide-details
          >
          </v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn color="error" text @click="dialogRequisicionesPendientes = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <!-- Boton para generar las requisiciones, partidas multiples -->
          <v-btn
            color="primary"
            :disabled="pagosPendientesSeleccionados.length === 0 || comentariosRequi === ''"
            :loading="generandoRequisiciones"
            @click="generarRequisicionesPendientes"
          >
            Generar {{ pagosPendientesSeleccionados.length }} Requisiciones
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo de editar o agregar-->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItem.id_servicio_sistema }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            :items="elementos"
            v-model="editedItem.id_elemento_mantenimiento"
            @change="onElementoSeleccionado"
            item-text="elemento_mantenimiento"
            item-value="id_elemento_mantenimiento"
            label="Seleccionar Elemento de compra"
            filled
            dense
          ></v-autocomplete>

          <v-autocomplete
            :items="categorias"
            v-model="editedItem.id_tipo_elemento"
            label="Categoría"
            filled
            dense
            item-text="tipo_requisicion"
            item-value="idtipo_requisiciones"
            @change="getComentariosCategorias()"
          ></v-autocomplete>

          <v-textarea
            v-if="editedIndex !== -1"
            v-model="editedItem.comentarios_categoria"
            label="Comentarios Categoria"
            filled
            rows="3"
            auto-grow
            readonly
          ></v-textarea>
          <v-textarea
            v-else
            v-model="dato_categoria"
            label="Comentarios Categoria"
            filled
            rows="3"
            auto-grow
            readonly
          ></v-textarea>

          <v-text-field
            v-model="editedItem.cuenta"
            label="No. Servicio"
            filled
            dense
          ></v-text-field>

          <v-text-field
            v-model.number="editedItem.monto_solicitado"
            label="Monto"
            type="number"
            min="0"
            step="0.01"
            filled
            dense
          ></v-text-field>

          <v-autocomplete
            filled
            dense
            clearable
            v-model="editedItem.idproveedores"
            :items="proveedores"
            label="Selecciona proveedor"
            persistent-hint
            item-text="nombre_comercial"
            item-value="idproveedores"
            :error-messages="proveedorError"
            required
          >
          </v-autocomplete>

          <v-autocomplete
            v-model="editedItem.id_plantel"
            :items="planteles"
            item-text="plantel"
            item-value="id_plantel"
            label="Plantel"
            filled
            dense
          ></v-autocomplete>

          <v-select
            v-model.number="editedItem.dia_vencimiento"
            :items="diasVencimiento"
            label="Día de vencimiento"
            filled
            dense
            hint="Día del mes en que vence el egreso. El próximo vencimiento se recalcula automáticamente cada mes."
            persistent-hint
          ></v-select>

          <v-alert
            v-if="editedItem.dia_vencimiento"
            dense
            text
            type="info"
            class="mb-0"
          >
            Próximo vencimiento estimado:
            <strong>{{ buildFechaVencimientoDesdeDia(editedItem.dia_vencimiento) }}</strong>
          </v-alert>

          <v-textarea
            v-model="editedItem.comentarios"
            label="Comentarios"
            filled
            rows="3"
            auto-grow
          ></v-textarea>

          <v-radio-group v-model="editedItem.recurrencia">
            <v-subheader>Recurrencia de pago:</v-subheader>
            <v-radio label="Diario" value="1"></v-radio>
            <v-radio label="Mensual" value="2"></v-radio>
            <v-radio label="Bimestral" value="3"></v-radio>
            <v-radio label="Anual" value="4"></v-radio>
            <v-radio label="Catorcenal" value="5"></v-radio>
            <v-radio label="No Aplica" value="0"></v-radio>
            <v-radio label="Semanal" value="6"></v-radio>
          </v-radio-group>

          <v-switch
            label="¿Activo Si/No?"
            hide-details
            v-model="editedItem.activo_sn"
          ></v-switch>

          <div class="text-subtitle-1"><b>Fecha alta:</b> {{ editedItem.fecha_alta }}</div>
          <div class="text-subtitle-1"><b>Fecha baja:</b> {{ editedItem.fecha_baja }}</div>
        </v-card-text>

        <v-card-actions>
          <v-btn color="black" tile dark small @click="close">
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" tile dark small @click="save">
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el servicio?
                  <v-card-actions class="pt-6">
                    <v-btn color="error" text class="mr-2" @click="closeDelete()">
                      No, cancelar
                    </v-btn>
                    <v-btn color="#5C5C5C" dark class="elevation-6" @click="deleteItemConfirm()">
                      Si
                    </v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal para agregar/editar pago programado -->
      <v-dialog v-model="dialogPagoProgramado" max-width="600px">
        <v-card>
          <v-card-title class="headline primary white--text">
            {{ modoEdicion ? 'Editar' : 'Nuevo' }} Pago Programado
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogPagoProgramado = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-4">
            <v-form ref="formPagoProgramado" v-model="formValido">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="nuevoPago.monto_solicitado"
                    label="Monto*"
                    type="number"
                    prefix="$"
                    :rules="[v => !!v || 'El monto es requerido', v => v > 0 || 'El monto debe ser mayor a 0']"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="nuevoPago.proveedor"
                    :items="proveedores"
                    item-text="nombre"
                    item-value="id"
                    label="Proveedor*"
                    :rules="[v => !!v || 'El proveedor es requerido']"
                    required
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="nuevoPago.ciclo"
                    :items="ciclos"
                    item-text="nombre"
                    item-value="id"
                    label="Ciclo*"
                    :rules="[v => !!v || 'El ciclo es requerido']"
                    required
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="nuevoPago.servicio"
                    label="Servicio/Elemento de compra*"
                    :rules="[v => !!v || 'El servicio es requerido']"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="modoEdicion && evidenciaUrl">
                  <div class="d-flex align-center mb-2">
                    <span class="mr-2">Evidencia actual:</span>
                    <v-btn
                      x-small
                      icon
                      color="primary"
                      @click="verEvidencia(evidenciaActual)"
                    >
                      <v-icon small>mdi-image</v-icon>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-file-input
                    v-model="nuevoPago.evidencia"
                    label="Evidencia de pago (opcional)"
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    prepend-icon="mdi-file-image"
                    :show-size="true"
                    hint="Formatos aceptados: JPG, JPEG, PNG, WEBP"
                    persistent-hint
                    clearable
                  ></v-file-input>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="nuevoPago.comentarios"
                    label="Comentarios"
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-col cols="12">
            <v-divider class="my-3"></v-divider>
            <v-switch
              v-model="generarPagosRecurrentes"
              label="Generar pagos recurrentes según la recurrencia del servicio"
              hint="Activar para generar automáticamente los pagos futuros"
              persistent-hint
            ></v-switch>
          </v-col>

          <v-col cols="12" v-if="generarPagosRecurrentes">
            <v-menu
              v-model="menuFechaLimite"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaLimiteRecurrencia"
                  label="Generar pagos hasta esta fecha"
                  prepend-icon="mdi-calendar-end"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :hint="`Se generarán aproximadamente ${cantidadPagosAGenerar} pagos`"
                  persistent-hint
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaLimiteRecurrencia"
                @input="menuFechaLimite = false; calcularCantidadPagos()"
                locale="es-mx"
                :min="nuevoPago.fechaVencimiento"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="dialogPagoProgramado = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              @click="guardarPagoProgramado"
              :loading="guardandoPago"
              :disabled="!formValido"
            >
              {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </v-container>


</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'
import HistorialServicio from '../../components/HistorialServicio.vue'

export default {
  mixins: [validarErrores, funcionesExcel],

  components: {
    Alerta,
    carga,
    HistorialServicio,
  },

  data: () => ({

    generarPagosRecurrentes: false,
    menuFechaLimite: false,
    fechaLimiteRecurrencia: null,
    guardandoPago: false,
    formValido: false,
    modoEdicion: false,
    ciclos: [],
    loadingCiclos: false,
    dialogPagoProgramado: false,

    opEscuela: 3,

    nuevoPago: {
      id_pago: null,
      monto_solicitado: 0,
      fechaVencimiento: new Date().toISOString().substr(0, 10),
      proveedor: null,
      servicio: '',
      ciclo: null,
      comentarios: '',
      imagen: null
    },

    parametros: {
      dialogError: false,
      mensaje: '',
      color: '',
    },
    cargar: false,
    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    search: '',
    filtroFechaInicio: null,
    filtroFechaFin: null,
    filtroCategoria: null,
    diasVencimiento: Array.from({ length: 31 }, (_, i) => i + 1),
    servicios_sistemas: [],
    planteles: [],
    categorias: [],
    dato_categoria: '',
    elementos: [],
    proveedores: [],
    proveedorError: '',

    filtroVencimiento: 'todos',

    dialogRequisicionesPendientes: false,
    pagosPendientes: [],
    pagosPendientesSeleccionados: [],
    loadingPagosPendientes: false,
    generandoRequisiciones: false,

    editedItem: {
      id_servicio_sistema: 0,
      servicio: '',
      egreso_programado: '',
      cuenta: '',
      fecha_vencimiento: '',
      monto_solicitado: 0,
      monto_pagado: 0,
      id_plantel: 0,
      recurrencia: 0,
      id_usuario_ultimo_cambio: 0,
      id_tipo_elemento: 0,
      comentarios_categoria: '',
      comentarios: '',
      activo_sn: true,
      fecha_alta: '',
      fecha_baja: '',
      proveedor: null,
      idproveedores: null,
      id_elemento_mantenimiento: null,
      dia_vencimiento: 1,
      deleted: 0,
    },

    defaultItem: {
      id_servicio_sistema: 0,
      servicio: '',
      egreso_programado: '',
      cuenta: '',
      fecha_vencimiento: '',
      monto_solicitado: 0,
      monto_pagado: 0,
      id_plantel: 0,
      recurrencia: 0,
      id_usuario_ultimo_cambio: 0,
      id_tipo_elemento: 0,
      comentarios_categoria: '',
      comentarios: '',
      activo_sn: true,
      fecha_alta: '',
      fecha_baja: '',
      proveedor: null,
      idproveedores: null,
      id_elemento_mantenimiento: null,
      dia_vencimiento: 1,
      deleted: 0,
    },

    headers: [
      { text: "Egreso Programado", value: "egreso_programado" },
      { text: "Categoría", value: "categoria" },
      { text: "Plantel", value: "plantel" },
      { text: "Monto", value: "monto_solicitado" },
      { text: "Día de vencimiento", value: "dia_vencimiento" },
      { text: "Recurrente", value: "recurrencia" },
      { text: "Activo", value: "activo_sn" },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],

    pagosPendientesHeaders: [
      { text: 'Servicio'         , value: 'nombre_servicio'  },
      { text: 'Fecha Vencimiento', value: 'fechaVencimiento' },
      { text: 'Ciclo'            , value: 'ciclo_nombre'     },
      { text: 'Monto'            , value: 'monto_solicitado' },
      { text: 'Proveedor'        , value: 'proveedorNombre'  },
      { text: 'Plantel'          , value: 'plantel'          },
      { text: 'Actions'          , value: 'actions'          }
    ],

    opcionesFiltroVencimiento: [
      { text: 'Todos los pagos', value: 'todos' },
      { text: 'Vencen en 7 días', value: '7dias' },
      { text: 'Vencen en 15 días', value: '15dias' },
      { text: 'Vencen en 30 días', value: '30dias' },
      { text: 'Vencidos', value: 'vencidos' }
    ],

    comentariosRequi:'',

    searchPagos:'',

    fechaIni: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    formTitle() {
      return this.editedIndex === -1 ? 'Agregar Egreso Programado' : 'Editar Egreso Programado'
    },

    categoriasFiltro() {
      return (this.categorias || []).map(cat => ({
        text: cat.tipo_requisicion,
        value: cat.idtipo_requisiciones,
      }))
    },

    serviciosSistemasFiltrados() {
      let lista = Array.isArray(this.servicios_sistemas) ? [...this.servicios_sistemas] : []

      if (this.filtroCategoria) {
        lista = lista.filter(item => Number(item.id_tipo_elemento) === Number(this.filtroCategoria))
      }

      if (this.filtroFechaInicio || this.filtroFechaFin) {
        lista = lista.filter(item => {
          const proximo = this.calcularProximoVencimiento(item)
          if (!proximo) return false
          if (this.filtroFechaInicio && proximo < this.filtroFechaInicio) return false
          if (this.filtroFechaFin && proximo > this.filtroFechaFin) return false
          return true
        })
      }

      return lista
    },

    pagosPendientesFiltrados() {
      // if (this.filtroVencimiento === 'todos') {
      //   return this.pagosPendientes;
      // }

      // const hoy = new Date();
      // const diasFiltro = {
      //   '7dias': 7,
      //   '15dias': 15,
      //   '30dias': 30,
      //   'vencidos': 0
      // };

      console.log( this.pagosPendientes )

      let  data = this.pagosPendientes

      if( this.opEscuela == 1 ){

        data = data.filter( el => !el.ciclo_nombre.match('FE') )

      }


      if( this.opEscuela == 2 ){

        data = data.filter( el => el.ciclo_nombre.match('FE') )

      }


      return data.filter( el => el.fechaVencimiento >= this.fechaIni && el.fechaVencimiento <= this.fechafin );
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },

    pagosPendientesSeleccionados: {
      handler(newVal) {
        if (!Array.isArray(newVal)) {
          this.pagosPendientesSeleccionados = [];
          console.log('Seleccionados: Array reiniciado porque no era un array');
        } else {
          console.log('Seleccionados:', newVal.length);
        }
        // Forzar actualización del DOM
        this.$forceUpdate();
      },
      deep: true
    },

    // Reiniciar selección al abrir/cerrar diálogo
    dialogRequisicionesPendientes(val) {
      if (!val) {
        // Al cerrar el diálogo, limpiamos completamente
        this.$nextTick(() => {
          this.pagosPendientesSeleccionados = [];
          this.filtroVencimiento = 'todos';
          //this.$forceUpdate();
        });
      }
    }
  },

  async created() {
    this.inicializarFiltrosFecha()
    await this.initialize()
    await this.getPlanteles()
    await this.getCategorias()
    await this.getProveedores()
    await this.cargarCiclos( )
  },

  methods: {
    inicializarFiltrosFecha() {
      const hoy = new Date()
      const year = hoy.getFullYear()
      const month = hoy.getMonth()
      const inicio = new Date(year, month, 1)
      const fin = new Date(year, month + 1, 0)
      this.filtroFechaInicio = inicio.toISOString().slice(0, 10)
      this.filtroFechaFin = fin.toISOString().slice(0, 10)
    },

    fmtFechaKey(fecha) {
      if (!fecha) return ''
      return String(fecha).slice(0, 10)
    },

    extraerDiaVencimiento(fecha) {
      const key = this.fmtFechaKey(fecha)
      if (!key) return 1
      const dia = parseInt(key.slice(8, 10), 10)
      return Number.isFinite(dia) && dia >= 1 && dia <= 31 ? dia : 1
    },

    buildFechaVencimientoDesdeDia(dia) {
      const diaNum = Number(dia)
      if (!Number.isFinite(diaNum) || diaNum < 1 || diaNum > 31) return ''

      const hoy = new Date()
      const hoySinHora = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 12)

      for (let offset = 0; offset < 13; offset++) {
        const candidato = new Date(hoy.getFullYear(), hoy.getMonth() + offset, diaNum, 12)
        if (candidato.getDate() !== diaNum) continue
        if (candidato >= hoySinHora) {
          return candidato.toISOString().slice(0, 10)
        }
      }

      return new Date(hoy.getFullYear(), hoy.getMonth() + 1, diaNum, 12).toISOString().slice(0, 10)
    },

    calcularProximoVencimiento(item) {
      const recurrencia = Number(item.recurrencia)
      const fechaBase = this.fmtFechaKey(item.fecha_vencimiento)
      const dia = this.extraerDiaVencimiento(item.fecha_vencimiento)
      const hoy = new Date()
      const hoyKey = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()).toISOString().slice(0, 10)

      if (recurrencia === 1) return hoyKey

      if (recurrencia === 6 && fechaBase) {
        const diaSemana = new Date(`${fechaBase}T12:00:00`).getDay()
        const cursor = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 12)
        for (let i = 0; i < 7; i++) {
          if (cursor.getDay() === diaSemana) {
            return cursor.toISOString().slice(0, 10)
          }
          cursor.setDate(cursor.getDate() + 1)
        }
      }

      if ([0, 2, 3, 4, 5].includes(recurrencia) || !recurrencia) {
        return this.buildFechaVencimientoDesdeDia(dia)
      }

      return fechaBase && fechaBase >= hoyKey ? fechaBase : this.buildFechaVencimientoDesdeDia(dia)
    },

    getDiaVencimientoTexto(item) {
      const recurrencia = Number(item.recurrencia)
      const fechaBase = this.fmtFechaKey(item.fecha_vencimiento)

      if (recurrencia === 1) return 'Diario'
      if (!fechaBase) return '-'

      if (recurrencia === 6) {
        const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
        return dias[new Date(`${fechaBase}T12:00:00`).getDay()]
      }

      const dia = this.extraerDiaVencimiento(fechaBase)
      return `Día ${dia}`
    },

    getProximoVencimientoLabel(item) {
      const proximo = this.calcularProximoVencimiento(item)
      if (!proximo) return ''
      const [year, month, day] = proximo.split('-')
      return `${day}/${month}/${year}`
    },

    getNombreCategoria(idCategoria) {
      const cat = (this.categorias || []).find(
        c => Number(c.idtipo_requisiciones) === Number(idCategoria)
      )
      return cat ? cat.tipo_requisicion : 'Categoría'
    },
    async initialize() {
      try {
        this.cargar = true
        const [responseServicios, responseElementos] = await Promise.all([
          this.$http.get('servicios_sistemas.list'),
          this.$http.get('consultar.elemtos.compra')
        ]);

        this.elementos = responseElementos.data;

        this.servicios_sistemas = responseServicios.data.map(item => {
          const fechaVencimiento = this.fmtFechaKey(item.fecha_vencimiento)
          return {
            ...item,
            activo_sn: item.activo_sn !== undefined ? item.activo_sn : 1,
            egreso_programado: item.egreso_programado || item.servicio,
            servicio: item.servicio || item.egreso_programado,
            proveedor: item.idproveedores,
            idproveedores: item.idproveedores,
            id_elemento_mantenimiento: item.id_elemento_mantenimiento,
            fecha_vencimiento: fechaVencimiento,
            dia_vencimiento: this.extraerDiaVencimiento(fechaVencimiento),
            tipo_requisicion: item.tipo_requisicion || null,
            id_tipo_elemento: item.id_tipo_elemento || item.idtipo_requisiciones || 0,
          };
        });
      } catch (error) {
        const errorMessage = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Error al cargar los datos';
        this.validarError(errorMessage);
      } finally {
        this.cargar = false;
      }
    },

    async cargarCiclos() {
        this.loadingCiclos = true;
        try {
          const response = await this.$http.get("ciclos.list");
          // Mapear la respuesta para adaptarla al formato que necesita el componente
          this.ciclos = response.data.map(ciclo => ({
            id: ciclo.id_ciclo,
            nombre: ciclo.ciclo,
            fechaInicio: ciclo.fecha_inicio_ciclo,
            fechaFin: ciclo.fecha_fin_ciclo,
            activo: ciclo.activo_sn === '1' || ciclo.activo_sn === 1
          }));

          // Filtrar solo ciclos activos y ordenar por fecha de inicio (más recientes primero)
          this.ciclos = this.ciclos
            .filter(ciclo => ciclo.activo)
            .sort((a, b) => new Date(b.fechaInicio) - new Date(a.fechaInicio));

        } catch (error) {
          console.error('Error al cargar ciclos:', error);
          this.$emit('mostrar-error', 'Error al cargar la lista de ciclos');
        } finally {
          this.loadingCiclos = false;
        }
      },

    onElementoSeleccionado(elemento) {

      const elementoSeleccionado = this.elementos.find(
        item => item.id_elemento_mantenimiento === elemento
      );
      console.log( elementoSeleccionado )

      if (elementoSeleccionado) {
        this.editedItem.servicio = elementoSeleccionado.elemento_mantenimiento;
        this.editedItem.egreso_programado = elementoSeleccionado.elemento_mantenimiento;
        this.editedItem.id_plantel        = elementoSeleccionado.id_plantel;
        this.editedItem.idproveedores     = elementoSeleccionado.idproveedores;
        this.editedItem.id_tipo_elemento  = elementoSeleccionado.id_tipo_elemento;
        this.editedItem.comentarios       = elementoSeleccionado.comentarios;
        this.editedItem.cuenta            = elementoSeleccionado.no_servicio;

        if (elementoSeleccionado.id_tipo_elemento) {
          this.getComentariosCategorias();
        }
      }
    },

    getProveedores() {
      this.cargar = true;
      return this.$http.get("proveedores.list.erp").then((response) => {
        this.proveedores = response.data;
        console.log( 'wrvrvwr',this.proveedores )
      }).catch((error) => {
        this.validarError(error);
      }).finally(() => {
        this.cargar = false;
      });
    },

    getPlanteles() {
      this.cargar = true;
      return this.$http.get('planteles.list.erp').then(response => {
        this.planteles = response.data;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => {
        this.cargar = false;
      });
    },

    getCategorias() {
      this.cargar = true;
      return this.$http.get('consultar.requisiciones').then(response => {
        this.categorias = response.data;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => {
        this.cargar = false;
      });
    },

    editItem(item) {
      this.editedIndex = this.servicios_sistemas.indexOf(item);

      // Crear una copia limpia del item
      this.editedItem = {
        ...this.defaultItem,
        ...item,
        servicio: item.servicio || item.egreso_programado,
        idproveedores: item.idproveedores,
        id_elemento_mantenimiento: item.id_elemento_mantenimiento,
        recurrencia: String(item.recurrencia || '0'),
        activo_sn: !!item.activo_sn,
        dia_vencimiento: item.dia_vencimiento || this.extraerDiaVencimiento(item.fecha_vencimiento),
        id_tipo_elemento: item.id_tipo_elemento || item.idtipo_requisiciones || 0,
      };

      if (this.editedItem.id_tipo_elemento) {
        this.getComentariosCategorias();
      }

      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.dato_categoria = '';
        this.proveedorError = '';
      });
    },

    deleteItem(item) {
      this.editedIndex = this.servicios_sistemas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.cargar = true;
      try {
        const datos = {
          ...this.editedItem,
          deleted: 1,
          activo_sn: 0
        };

        await this.$http.put(`servicios_sistemas.update.erp/${this.editedItem.id_servicio_sistema}`, datos);
        this.closeDelete();
        await this.initialize();
      } catch (error) {
        this.validarError(error.response.data.message);
      } finally {
        this.cargar = false;
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.cargar = true;
      this.proveedorError = '';
      try {
        if (!this.editedItem.idproveedores) {
          this.proveedorError = 'El proveedor es obligatorio';
          this.cargar = false;
          return;
        }
        if (!this.editedItem.id_tipo_elemento) {
          this.validarErrorDirecto('La categoría es obligatoria');
          this.cargar = false;
          return;
        }
        const fechaVencimiento = this.buildFechaVencimientoDesdeDia(this.editedItem.dia_vencimiento)
        // Datos estandarizados para enviar a la API
        const datos = {
          id_servicio_sistema: this.editedItem.id_servicio_sistema,
          servicio: this.editedItem.servicio,
          egreso_programado: this.editedItem.servicio, // Mantener compatibilidad
          id_elemento_mantenimiento: this.editedItem.id_elemento_mantenimiento,
          cuenta: this.editedItem.cuenta || '',
          fecha_vencimiento: fechaVencimiento || null,
          monto_solicitado: this.editedItem.monto_solicitado || 0,
          monto_pagado: this.editedItem.monto_pagado || 0,
          id_plantel: this.editedItem.id_plantel || null,
          recurrencia: this.editedItem.recurrencia || '0',
          id_tipo_elemento: this.editedItem.id_tipo_elemento || 0,
          comentarios_categoria: this.editedItem.comentarios_categoria || '',
          comentarios: this.editedItem.comentarios || '',
          activo_sn: this.editedItem.activo_sn !== undefined ? this.editedItem.activo_sn : true,
          id_usuario_ultimo_cambio: this.getdatosUsuarioERPERP.iderp,
          idproveedores: this.editedItem.idproveedores,
          deleted: 0
        };

        if (this.editedIndex > -1) {
          // Actualizar
          const response = await this.$http.put(
            `servicios_sistemas.update.erp/${this.editedItem.id_servicio_sistema}`,
            datos
          );
          this.validarSuccess(response.data.message);
        } else {
          // Agregar
          await this.$http.post('servicios_sistemas.add.erp', datos);
        }

        await this.initialize();
        this.close();
      } catch (error) {
        const errorMessage = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Error al guardar';
        this.validarError(errorMessage);
      } finally {
        this.cargar = false;
      }
    },

    getComentariosCategorias() {
      this.cargar = true;
      this.dato_categoria = '';

      const payload = {
        idtipo_requisiciones: this.editedItem.id_tipo_elemento,
      };

      return this.$http.post('get.info.categoria', payload).then(response => {
        this.dato_categoria = response.data.comentarios;
        this.editedItem.comentarios_categoria = this.dato_categoria;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => {
        this.cargar = false;
      });
    },

    getRecurrenciaText(value) {
      const recurrencias = {
        0: "No Aplica",
        1: "Diario",
        2: "Mensual",
        3: "Bimestral",
        4: "Anual",
        5: "Catorcenal",
        6: "Semanal"
      };
      return recurrencias[value] || "";
    },

    async abrirModalRequisicionesPendientes() {
      // Aseguramos que sea un array vacío, no null
      this.pagosPendientesSeleccionados = [];
      this.filtroVencimiento = 'todos'; // Reiniciar el filtro al abrir
      this.dialogRequisicionesPendientes = true;

      await this.cargarPagosPendientes();

      // Añadir un pequeño retraso puede ayudar a que la tabla se actualice correctamente
      this.$nextTick(() => {
        // Doble verificación de que sea un array
        if (!Array.isArray(this.pagosPendientesSeleccionados)) {
          this.pagosPendientesSeleccionados = [];
        }
        this.$forceUpdate();
      });
    },

    async cargarPagosPendientes() {
      this.loadingPagosPendientes = true;
      this.pagosPendientes = [];
      try {
        // Llamada a la API para obtener todos los pagos pendientes sin requisición
        const response = await this.$http.get('servicios_sistemas.list.pagos.sin.requisicion');

        console.log( response.data.filter( el => el.id_servicio == 183 ) )

        this.pagosPendientes = response.data.map(pago => ({
          id_pago: pago.id_pago,
          id_servicio: pago.id_servicio,
          nombre_servicio: pago.nombre_servicio,
          fechaVencimiento: pago.fecha_vencimiento,
          monto_solicitado: pago.monto_solicitado,
          proveedor: pago.id_proveedor,
          id_proveedor: pago.id_proveedor,
          proveedorNombre: pago.id_proveedor_nombre,
          ciclo: pago.id_ciclo,
          id_ciclo: pago.id_ciclo,
          plantel: pago.plantel || 'No especificado',
          id_plantel: pago.id_plantel,
          ciclo_nombre: pago.ciclo_nombre,
          id_servicio: pago.id_servicio
        }));
        this.$nextTick(() => {
          this.pagosPendientesSeleccionados = [];
          this.$forceUpdate();
        });
      } catch (error) {
        console.error('Error al cargar pagos pendientes:', error);
        this.validarError('Error al cargar los pagos pendientes sin requisición');
      } finally {
        this.loadingPagosPendientes = false;
      }
    },

    async generarRequisicionesPendientes() {
      if (!Array.isArray(this.pagosPendientesSeleccionados) || this.pagosPendientesSeleccionados.length === 0) {
        this.validarError('No hay pagos seleccionados para generar requisiciones');
        return;
      }

      this.generandoRequisiciones = true;

      const resultados = {
        exitosos: 0,
        fallidos: 0,
        errores: []
      };


      try {

        const { id_plantel, ciclo, proveedor, id_servicio, nombre_servicio, monto_solicitado, id_pago } = this.pagosPendientesSeleccionados[0]
      
        // Payload para la requisición
        let payload = {
          registro: null,
          id_usuario_solicita: this.getdatosUsuarioERPERP.iderp,
          id_sucursal_solicita: id_plantel || this.getdatosUsuarioERPERP.id_plantel,
          id_requisicion_compra_estatus: 1,
          id_usuario_ultimo_cambio: this.getdatosUsuarioERPERP.iderp,
          id_usuario_compra: 28,
          tipo_requisicion: 1, // Ajustar según tu lógica de negocio
          id_ciclo: ciclo,
          id_proyecto: null,
          idproveedores: proveedor,
          idservicios_sistemas: id_servicio,
          comentarios: `${this.comentariosRequi}`,
          monto: monto_solicitado,
          id_elemento_requisicion: 1,
          detalles: [],
          fotos: [],
          // Agregar el ID del pago para vincularlo con la requisición
          id_pago_programado: id_pago
        };

        /// Para cada pago seleccionado, generamos su requisición
        for (const pago of this.pagosPendientesSeleccionados) {
          // Payload para la requisición
          let detalle = {
            id_elemento_requisicion: 1,
            id_plantel: pago.id_plantel || this.getdatosUsuarioERPERP.id_plantel,
            concepto: `Pago de Servicio: ${pago.nombre_servicio}`,
            cantidad: 1,
            costo_unitario: pago.monto_solicitado,
            costo_total: pago.monto_solicitado,
            id_usuario_ultimo_cambio: this.getdatosUsuarioERPERP.iderp,
            id_empleado: this.getdatosUsuarioERPERP.iderp,
            id_alumno: null,
            id_grupo: null,
            id_plantel_resultados: pago.id_plantel || this.getdatosUsuarioERPERP.id_plantel,
            idhistorial_nomina: null,
            id_pago_programado: pago.id_pago

          };

          payload.detalles.push( detalle )
        }

        // Enviar requisición
        const response = await this.$http.post('generar.requi.detalles', payload);

        if (response.data && response.data.idrequisicion_compra) {
          resultados.exitosos++;
        } else {
          resultados.fallidos++;
          resultados.errores.push(`Error al generar requisición para: ${pago.nombre_servicio}`);
        }

        // Mostrar resumen
        if (resultados.exitosos > 0) {
          this.validarSuccess(`Se generaron ${resultados.exitosos} requisiciones correctamente`);
        }

        if (resultados.fallidos > 0) {
          this.validarError(`No se pudieron generar ${resultados.fallidos} requisiciones. Revise el log para más detalles.`);
          console.error('Errores en generación de requisiciones:', resultados.errores);
        }

        // Actualizar la lista para no mostrar los ya procesados
        if (resultados.exitosos > 0) {
          this.comentariosRequi = ''
          this.pagosPendientesSeleccionados = []
          await this.cargarPagosPendientes();
        }

        // Cerrar el modal si todo fue exitoso
        if (resultados.fallidos === 0) {
          this.dialogRequisicionesPendientes = false;
        }

      } catch (error) {
        console.error('Error general al generar requisiciones:', error);
        this.validarError('Ocurrió un error al procesar las requisiciones pendientes');
      } finally {
        this.generandoRequisiciones = false;
      }
    },

    formatFecha(fecha) {
      return new Date(fecha).toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(value);
    },

    getDiasFaltantes(fechaVencimiento) {
      const hoy = new Date();
      const fechaVence = new Date(fechaVencimiento);
      const diferencia = fechaVence - hoy;
      return Math.ceil(diferencia / (1000 * 60 * 60 * 24));
    },

    getVencimientoRowClass(item) {
      const dias = this.getDiasFaltantes(item.fechaVencimiento);
      if (dias < 0) return 'grey lighten-4';
      return '';
    },

    getVencimientoTextClass(item) {
      const dias = this.getDiasFaltantes(item.fechaVencimiento);
      if (dias < 0) return 'error--text';
      if (dias <= 3) return 'red--text text--darken-1 font-weight-bold';
      if (dias <= 7) return 'orange--text text--darken-1 font-weight-bold';
      if (dias <= 15) return 'amber--text text--darken-2';
      return '';
    },
    actualizarSeleccion(items) {
      console.log('Selección actualizada:', items.length);
      // Asegurarse de que sea siempre un array
      this.pagosPendientesSeleccionados = Array.isArray(items) ? items : [];
      this.$forceUpdate();
    },

    async saveMonto( item ){

      try{
        // Enviar requisición
        const response = await this.$http.post('update.requi.pendiente', item);

        await this.cargarPagosPendientes();

      }catch( error ){
        this.validarError( error.data )
      }

    },

    editarPagoProgramado(item) {
      this.modoEdicion = true;
      this.nuevoPago = {
        id_pago         : item.id_pago,
        monto_solicitado: item.monto_solicitado,
        fechaVencimiento: item.fechaVencimiento,
        id_servicio     : item.id_servicio,
        proveedor       : item.id_proveedor,
        servicio        : item.nombre_servicio,
        ciclo           : item.id_ciclo,
        comentarios     : item.comentarios || '',
        evidencia       : null
      };
      // Si hay evidencia, guardamos la URL para mostrarla
      if (item.evidencia) {
        this.evidenciaActual = item.evidencia;
        this.evidenciaUrl = `./../../imagenes-servicios/${item.evidencia}`;
      } else {
        this.evidenciaActual = null;
        this.evidenciaUrl = null;
      }
      this.dialogPagoProgramado = true;
    },

    async guardarPagoProgramado() {
        if (!this.$refs.formPagoProgramado.validate()) return;

        // Si no estamos generando pagos recurrentes o estamos en modo edición, usar la lógica original
        if (!this.generarPagosRecurrentes || this.modoEdicion) {
          // Llamar al método original
          await this.guardarPagoSimple();
        } else {
          // LÓGICA PARA PAGOS RECURRENTES
          // Generar fechas según la recurrencia
          const fechasGeneradas = this.generarFechasRecurrentes(
            this.nuevoPago.fechaVencimiento,
            this.fechaLimiteRecurrencia,
            this.servicio.recurrencia
          );

          // Preparar el resumen de pagos a crear
          this.pagosACrear = [];

          for (let i = 0; i < fechasGeneradas.length; i++) {
            const fechaPago = fechasGeneradas[i].fecha;

            // Buscar ciclo para esta fecha
            let cicloPago = await this.buscarCicloPorFecha(fechaPago);
            let nombreCiclo, idCiclo;

            // Si no encontramos un ciclo en la base de datos, inferimos el nombre
            if (!cicloPago) {

              // Lo brincamoss
              continue;

              const nombreCicloInferido = this.inferirNombreCiclo(fechaPago);
              const cicloInfo = this.buscarCicloPorNombre(nombreCicloInferido);

              // Si tenemos un ID de ciclo, lo usamos
              if (cicloInfo) {
                idCiclo = cicloInfo.id;
                nombreCiclo = cicloInfo.nombre;
              } else {

                continue
                // Si no tenemos ID, usamos el ciclo del primer pago como fallback para el primer pago
                // idCiclo = i === 0 ? this.nuevoPago.ciclo : null;
                // nombreCiclo = cicloInfo.nombre;
              }
            } else {
              // Si encontramos un ciclo, obtenemos su nombre
              idCiclo = cicloPago;
              const cicloSeleccionado = this.ciclos.find(c => c.id === cicloPago);
              nombreCiclo = cicloSeleccionado ? cicloSeleccionado.nombre : `Ciclo para ${fechaPago}`;
            }

            // Añadir a la lista de pagos a crear
            this.pagosACrear.push({
              fecha: fechaPago,
              idCiclo: idCiclo,
              nombreCiclo: nombreCiclo
            });
          }

          // Mostrar diálogo de confirmación
          this.dialogConfirmacionMultiples = true;
        }
      },

      // Extraer la lógica original de guardar un solo pago en un método separado
      async guardarPagoSimple() {
        this.guardandoPago = true;

        try {
          // Obtener el ID correcto del servicio
          const idServicio = this.nuevoPago.id_servicio || this.nuevoPago.id_servicio;

          // Buscar el nombre del proveedor seleccionado
          const proveedorSeleccionado = this.proveedores.find(p => p.id === this.nuevoPago.proveedor);
          const nombreProveedor = proveedorSeleccionado ? proveedorSeleccionado.nombre : 'No especificado';

          // Buscar el nombre del ciclo seleccionado
          const cicloSeleccionado = this.ciclos.find(c => c.id === this.nuevoPago.ciclo);
          const nombreCiclo = cicloSeleccionado ? cicloSeleccionado.nombre : 'No especificado';

          // Crear FormData para enviar archivos
          const formData = new FormData();

          // Añadir todos los campos del formulario al FormData
          formData.append('id_servicio', idServicio);
          formData.append('monto_solicitado', this.nuevoPago.monto_solicitado);
          formData.append('fecha_vencimiento', this.nuevoPago.fechaVencimiento);
          formData.append('id_proveedor', this.nuevoPago.proveedor);
          formData.append('id_proveedor_nombre', nombreProveedor);
          formData.append('nombre_servicio', this.nuevoPago.servicio);
          formData.append('id_ciclo', this.nuevoPago.ciclo);
          formData.append('id_ciclo_nombre', nombreCiclo);
          formData.append('comentarios', this.nuevoPago.comentarios);
          formData.append('monto_pagado', 0);

          if (this.modoEdicion && this.evidenciaActual && !this.nuevoPago.evidencia) {
            formData.append('evidencia_existente', this.evidenciaActual);
          }
          // Añadir la imagen si existe
          if (this.nuevoPago.evidencia) {
            formData.append('evidencia', this.nuevoPago.evidencia);
          }

          let response;

          // Configuración para la petición con FormData
          const config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };

          if (this.modoEdicion) {
            // Actualizar pago existente
            response = await this.$http.put(
              `servicios_sistemas.update.pago.erp/${this.nuevoPago.id_pago}`,
              formData,
              config
            );
            this.$emit('mostrar-exito', 'Pago programado actualizado correctamente');
          } else {
            // Crear nuevo pago
            response = await this.$http.post(
              'servicios_sistemas.add.pago.erp',
              formData,
              config
            );
            this.$emit('mostrar-exito', 'Pago programado creado correctamente');
          }

          // Recargar la lista completa
          await this.cargarPagosPendientes();

          // Cerrar el modal
          this.dialogPagoProgramado = false;
        } catch (error) {
          console.error('Error al guardar pago programado:', error);
          const errorMessage = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Error al guardar el pago programado';

          this.$emit('mostrar-error', errorMessage);
        } finally {
          this.guardandoPago = false;
        }
      },
  }
}
</script>

<style scoped>
.dia-vencimiento-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.dia-vencimiento-cell__proximo {
  font-size: 0.72rem;
  color: #78909c;
}
</style>
